module.exports = __webpack_public_path__ + "static/media/blogo.8f4065fd.png";